module.exports = __webpack_public_path__ + "img/LTS_SAIPA.fef62446.gif";